<template>
  <div id="messageHistory">
    <!-- 顶部筛选 -->
    <!-- <Form ref="params" :model="params" inline :label-width="100" :rules="ruleValidate">
      <FormItem prop="policyNo" label="保单号">
        <Input v-model="params.policyNo" placeholder="请输入保单号" />
      </FormItem>
      <FormItem prop="productName" label="产品名称">
        <Input v-model="params.productName" placeholder="请输入产品名称" />
      </FormItem>
      <FormItem prop="companyCode" label="保险公司">
        <Select v-model="params.companyCode" style="width: 162px" placeholder="请选择保险公司">
          <Option v-for="(item, index) in companyNameList" :value="item.compCode" :key="index">
            {{ item.compName }}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="status" label="确认状态">
        <Select v-model="params.status" style="width: 162px" placeholder="请选择确认状态">
          <Option value="1">是</Option>
          <Option value="0">否</Option>
        </Select>
      </FormItem>
      <FormItem prop="" label="">
        <Button @click="search()" class="ivu-btn ivu-btn-primary" style="margin-right: 5px">查询</Button>
        <Button @click="reset()">重置</Button>
      </FormItem>
    </Form> -->
    <div>
      <primaryTable
        :columns="columns"
        :data="tableList"
        ref="primaryTable"
        :loading="tableLoading"
        :total="total"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
        :current.sync="params.pageNum"
      ></primaryTable>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 10,
        tenementNo:sessionStorage.getItem('tenementNo'),
      },
      tableLoading: false,
      total: 0,
      //主险表头
      columns: [
        {
          title:'序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '消息类型',
          key: 'messageMold',
          align: 'center',
          render:(h,params)=>{
            let txt = params.row.messageMold == 0 ? '站内信' : '短信'
            return h('div',txt)
          }
        },
        {
          title: '业务类型',
          key: 'messageType',
          align: 'center',
          render:(h,params)=>{
            let txt = ''
            if(params.row.messageType == 1){
              txt = '系统公告'
            }else if(params.row.messageType == 2){
              txt = '产品动态'
            }else{
              txt = '/'
            }
            return h('div',txt)
          }
        },
        {
          title: '标题',
          key: 'detailButtonName',
          align: 'center',
        },
        {
          title: '模板内容',
          key: 'message',
          align: 'center',
        },
        {
          title: '发送时间',
          key: 'resSendDate',
          align: 'center',
        },
        {
          title: '发送状态',
          key: 'sendStatus',
          align: 'center',
          render:(h,params)=>{
            let txt = params.row.sendStatus == 0 ? '成功' : '失败'
            return h('div',txt)
          }
        },
      ],
      tableList: [], //主险
      loading: false,
      tenementNo: '',
    }
  },
  created: function () {
  },
  mounted: function () {
    this.search(1)
  },
  watch: {},
  methods: {
    search(page) {
      this.params.pageNum = page ? page : 1
      let searchData = { ...this.params }
      this.getList(searchData)
    },
    getList(data) {
      this.tableLoading = true
      this.$api.getMessageHistoryPage(data).then((res) => {
        this.tableLoading = false
        if (res.result == '0') {
          this.tableList = res.content.list
          this.total = res.content.total
        } else {
          this.$Message.error(res.resultMessage)
        }
      })
    },
    //换页
    changePage(page) {
      this.params.pageNum = page
      this.search(page)
    },
    //换页
    changePageSize(pageSize) {
      this.params.pageSize = pageSize
      this.search(1)
    },
  },
}
</script>

<style lang="less">
#messageHistory {
  .header {
    display: -webkit-flex;
    display: flex;
    justify-content: space-around;

    .left {
      width: 0px;
      flex-grow: 1;
    }
  }
}
//  .ivu-picker-panel-body {
//   float: left;
//   position: fixed !important;
//   background: #fff !important;
//   border: solid 1px #e3e3e3 !important;
// }
</style>
